export default "__VITE_ASSET__b12fd50c__"